import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, Activity, ShoppingBag, Globe } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const {
    lang,
    toggleLang,
    t
  } = useLanguage();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: t('nav.team'),
    href: '#team'
  }, {
    name: t('nav.matches'),
    href: '#matches'
  }, {
    name: t('nav.deals'),
    href: '#deals'
  }];
  const getNextLangLabel = () => {
    if (lang === 'en') return 'DE';
    if (lang === 'de') return 'ES';
    return 'EN';
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-germany-black/95 backdrop-blur-md py-4 shadow-lg border-b border-germany-platinum/10' : 'bg-transparent py-6'}`} data-id="element-282">
      <div className="container mx-auto px-6 md:px-12 flex justify-between items-center" data-id="element-283">
        {/* Logo Area */}
        <div className="flex items-center gap-3 z-50" data-id="element-284">
          <a href="#" className="flex items-center" data-id="element-285">
            <img src="https://cdn.magicpatterns.com/uploads/dHFF6t2sCE9DhuCAgyYxJp/ChatGPT_Image_Mar_30,_2026,_07_19_46_PM.png" alt="Qtap Logo" className="w-10 h-10 object-contain" decoding="async" data-id="element-286" />
          </a>
          <a href="https://shop.qtap.me/collections/world-cup-2026-smart-t-shirt" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1.5 bg-germany-red hover:bg-germany-dark-red text-white px-3 py-1.5 rounded-full font-oswald uppercase text-[11px] md:text-xs font-bold tracking-wider transition-colors duration-300 min-h-[36px]" data-id="element-287">
            <ShoppingBag size={13} data-id="element-288" />
            <span data-id="element-289">{t('nav.orderYours')}</span>
          </a>
          <button onClick={toggleLang} className="flex items-center gap-1.5 bg-white/10 hover:bg-white/20 border border-white/20 text-white px-3 py-1.5 rounded-full font-oswald uppercase text-[11px] md:text-xs font-bold tracking-wider transition-colors duration-300 min-h-[36px]" data-id="element-290">
            <Globe size={13} data-id="element-291" />
            <span data-id="element-292">{getNextLangLabel()}</span>
          </button>
        </div>
        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-293">
          {navLinks.map(link => <a key={link.name} href={link.href} className="font-oswald uppercase tracking-widest text-sm font-medium hover:text-germany-gold transition-colors duration-300 relative group min-h-[44px] flex items-center" data-id="element-294">
              {link.name}
              <span className="absolute bottom-1 left-0 w-0 h-0.5 bg-germany-gold transition-all duration-300 group-hover:w-full" data-id="element-295"></span>
            </a>)}
          <a href="https://www.espn.com/soccer/scoreboard/_/league/fifa.world" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 bg-germany-gold text-germany-black px-5 py-2 rounded-full font-oswald uppercase text-sm font-bold hover:bg-white transition-colors duration-300 min-h-[44px]" data-id="element-296">
            <Activity size={16} data-id="element-297" />
            <span data-id="element-298">{t('nav.liveScores')}</span>
          </a>
        </nav>
        {/* Mobile Menu Toggle */}
        <button className="md:hidden z-50 text-white p-2 min-h-[44px] min-w-[44px] flex items-center justify-center" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-299">
          {isMobileMenuOpen ? <X size={28} data-id="element-300" /> : <Menu size={28} data-id="element-301" />}
        </button>
        {/* Mobile Nav Dropdown */}
        <AnimatePresence data-id="element-302">
          {isMobileMenuOpen && <motion.div initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -10
        }} transition={{
          duration: 0.2
        }} className="absolute top-full left-0 right-0 bg-germany-black/95 backdrop-blur-md border-b border-white/10 z-40 px-6 py-6 flex flex-col gap-4 shadow-xl md:hidden" data-id="element-303">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="font-oswald text-lg uppercase tracking-widest hover:text-germany-gold transition-colors min-h-[44px] flex items-center" data-id="element-304">
                  {link.name}
                </a>)}
              <a href="https://www.espn.com/soccer/scoreboard/_/league/fifa.world" target="_blank" rel="noopener noreferrer" onClick={() => setIsMobileMenuOpen(false)} className="flex items-center justify-center gap-2 bg-germany-gold text-germany-black px-6 py-3 rounded-full font-oswald uppercase text-sm font-bold min-h-[44px] mt-2" data-id="element-305">
                <Activity size={16} data-id="element-306" />
                <span data-id="element-307">{t('nav.liveScores')}</span>
              </a>
            </motion.div>}
        </AnimatePresence>
      </div>
    </header>;
}